import { useTranslation } from '@sm360/hooks'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

import formatNumber from '../../../../../../utils/format-number.utils'

const Incentives = ({ incentives, priceRounding, extraClasses }) => {
    const {
        dealerRebates,
        dealerRebatesLabel,
        governmentRebates,
        governmentRebatesLabel,
        manufacturerRebates,
        manufacturerRebatesLabel,
    } = incentives || {}

    const { t } = useTranslation()

    const baseClass = 'vc-incentives'
    const classNames = clsx(baseClass, extraClasses)

    if (!dealerRebates && !governmentRebates && !manufacturerRebates) return null

    return (
        <div className={classNames}>
            {dealerRebates > 0 && (
                <div className={`${baseClass}__item`}>
                    <p className={`${baseClass}__title`}>{dealerRebatesLabel || t('paymentOptions.incentives.dealer')}</p>
                    <p className={`${baseClass}__value`}>- {formatNumber(dealerRebates, priceRounding)}</p>
                </div>
            )}

            {governmentRebates > 0 && (
                <div className={`${baseClass}__item`}>
                    <p className={`${baseClass}__title`}>{governmentRebatesLabel || t('paymentOptions.incentives.government')}</p>
                    <p className={`${baseClass}__value`}>- {formatNumber(governmentRebates, priceRounding)}</p>
                </div>
            )}

            {manufacturerRebates > 0 && (
                <div className={`${baseClass}__item`}>
                    <p className={`${baseClass}__title`}>
                        {manufacturerRebatesLabel || t('paymentOptions.incentives.manufacturer')}
                    </p>
                    <p className={`${baseClass}__value`}>- {formatNumber(manufacturerRebates, priceRounding)}</p>
                </div>
            )}
        </div>
    )
}

Incentives.propTypes = {
    /** Incentives */
    incentives: PropTypes.object,
    /** Extra classes */
    extraClasses: PropTypes.string,
    /** Rounding option for prices */
    priceRounding: PropTypes.string,
}

Incentives.defaultProps = {
    extraClasses: '',
    incentives: {},
    priceRounding: 'ROUND_UP',
}

export default Incentives
